import { PitchClassNames, PitchClassAliases, PitchClassMask } from ".";

export const pitchClassNames: () => PitchClassNames = () => [
   'C',    'C#', 'D',  'D#',   'E',    'F',    'F#', 'G',  'G#', 'A',  'A#',   'B'
];

export const pitchClassAliases: () => PitchClassAliases = () => [
  ['B#'], ['Db'], [], ['Eb'], ['Fb'], ['E#'], ['Gb'], [], ['Ab'], [], ['Bb'], ['Cb']
];

export const majorScalePitchClassMask: () => PitchClassMask = () => [
  1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1
];

export const naturalMinorScalePitchClassMask: () => PitchClassMask = () => [
  1, 0, 1, 1, 0, 1, 0, 1, 1, 0, 1, 0
];

export const harmonicMinorScalePitchClassMask: () => PitchClassMask = () => [
  1, 0, 1, 1, 0, 1, 0, 1, 1, 0, 0, 1
];

export const melodicMinorScalePitchClassMask: () => PitchClassMask = () => [
  1, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1
];

export const octaveStepMask: () => Array<0 | 1> = () =>  [
// C  D  E  F  G  A  B  C
   1, 1, 1, 1, 1, 1, 1, 1
];
export const pentatonicStepMask: () => Array<0 | 1> = () => [
// C  D  E  F  G  A  B  C  D  E  F  G 
   1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1
];
export const twoOctaveStepMask: () => Array<0 | 1> = () => [
// C  D  E  F  G  A  B  C  D  E  F  G  A  B  C
   1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1
];

